import React from 'react'
import ReactDOM from 'react-dom'
import createBrowserHistory from 'history/lib/createBrowserHistory'
import { useRouterHistory } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'
import createStore from './store/createStore'
import AppContainer from './containers/AppContainer'
import toBlob from 'canvas-to-blob'

import '../themes/inspinia/js/plugins/slimscroll/jquery.slimscroll.min'
import '../themes/inspinia/js/inspinia'
import '../themes/inspinia/js/plugins/pace/pace.min'
import '../themes/inspinia/js/plugins/imagePicker/image-picker'
import '../themes/inspinia/js/plugins/icheck/icheck'
import '../themes/inspinia/js/plugins/jasny/jasny-bootstrap.min'

import '../themes/inspinia/js/plugins/imagePicker/image-picker.css'
import '../themes/inspinia/js/plugins/icheck/skins/square/grey.css'
import '../themes/inspinia/js/plugins/jasny/jasny-bootstrap.min.css'


import '../themes/inspinia/css/bootstrap.css'
import '../themes/inspinia/css/bootstrap_xlgrid.css'
import '../themes/inspinia/font-awesome/css/all.min.css'
import '../themes/inspinia/css/animate.css'
import '../themes/inspinia/css/style.scss'

import 'react-select/dist/react-select.css'

import {RxEmitter} from "rxemitter"

window.rxemitter = RxEmitter

toBlob.init()

// ========================================================
// Browser History Setup
// ========================================================
const browserHistory = useRouterHistory(createBrowserHistory)({
  basename: __BASENAME__
})

// ========================================================
// Store and History Instantiation
// ========================================================
// Create redux store and sync with react-router-redux. We have installed the
// react-router-redux reducer under the routerKey "router" in src/routes/index.js,
// so we need to provide a custom `selectLocationState` to inform
// react-router-redux of its location.
const initialState = window.___INITIAL_STATE__
export const store = createStore(initialState, browserHistory)
const history = syncHistoryWithStore(browserHistory, store, {
  selectLocationState: (state) => state.router
})

// ========================================================
// Developer Tools Setup
// ========================================================
if (__DEBUG__) {
  if (window.devToolsExtension) {
    window.devToolsExtension.open()
    window.devToolsExtension.updateStore(store)
  }
}

// ========================================================
// Render Setup
// ========================================================
const MOUNT_NODE = document.getElementById('root')

let render = () => {
  const routes = require('./routes/index').default(store)

  ReactDOM.render(
    <AppContainer
      store={store}
      history={history}
      routes={routes}
    />,
    MOUNT_NODE
  )
}

// This code is excluded from production bundle
if (__DEV__) {
  if (module.hot) {
    // Development render functions
    const renderApp = render
    const renderError = (error) => {
      const RedBox = require('redbox-react').default

      ReactDOM.render(<RedBox error={error} />, MOUNT_NODE)
    }

    // Wrap render in try/catch
    render = () => {
      try {
        renderApp()
      } catch (error) {
        renderError(error)
      }
    }

    // Setup hot module replacement
    module.hot.accept('./routes/index', () => {
      setTimeout(() => {
        ReactDOM.unmountComponentAtNode(MOUNT_NODE)
        render()
      })
    })
  }
}

// ========================================================
// Go!
// ========================================================
render()



// WEBPACK FOOTER //
// ./src/main.js